import { persistCombineReducers } from "redux-persist";
import storage from "redux-persist/lib/storage";
import user from "./user";
import cart from "./cart";

const config = {
  key: "primary",
  storage,
};

const reducers = persistCombineReducers(config, {
  user,
  cart
});

export default reducers;
